export const getWindow = () => {
  return window.chekinCustomWindow || window;
};

export const getDocument = () => {
  return window.chekinCustomDocument || document;
};

export function getCustomContainer() {
  return getDocument()?.body;
}

export function isBrowser(): boolean {
  return typeof window !== 'undefined';
}

export function scrollToTop(value = 0, behavior?: 'auto' | 'smooth') {
  window.scrollTo({
    top: value,
    behavior,
  });
}

export function isObject<T>(value: T) {
  return value !== null && typeof value === 'object';
}

export const isNumeric = (n: string | number) => n !== '' && !isNaN(n as number);

export function toCssSize(size?: string | number) {
  if (!size) {
    return;
  } else if (size === 'auto') {
    return size;
  } else if (typeof size === 'number' || isNumeric(size)) {
    return `${size}px`;
  } else if (size.slice(-2) === 'px') {
    return size;
  } else {
    return size;
  }
}

export function getCanvasBlob(canvas: HTMLCanvasElement) {
  return new Promise<Blob | null>(resolve => {
    canvas.toBlob(blob => {
      resolve(blob);
    });
  });
}

export function toBase64(file: File | Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error('Failed to read file as base64'));
  });
}

export function getFileSizeMB(file?: File | Blob) {
  if (!file) return;
  return file.size / Math.pow(1024, 2);
}
